export class PrestacaoServicosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listPrestacaoServicos(filter) {
    const filtredParams = filter ? { ...filter } : {};

    delete filtredParams.intervalo;
    delete filtredParams.initial;

    return this.instance.get('/v1/ordem-servicos/', {
      params: filtredParams,
    });
  }

  showPrestacaoServico(id) {
    return this.instance.get(`/v1/ordem-servicos/${id}`);
  }

  createPrestacaoServico(data) {
    return this.instance.post(`/v1/ordem-servicos/`, data);
  }

  updatePrestacaoServico(id, data) {
    return this.instance.put(`/v1/ordem-servicos/${id}`, data);
  }

  removePrestacaoServico(id) {
    return this.instance.delete(`/v1/ordem-servicos/${id}`);
  }

  listOrdemPrestacaosItens(id, filter) {
    const filtredParams = filter ? { ...filter } : {};

    delete filtredParams.intervalo;
    delete filtredParams.initial;

    return this.instance.get(`/v1/ordem-servicos/${id}/ordem-servicos-itens`, {
      params: filtredParams,
    });
  }

  createPrestacaoServicoItens(ordemServicoId, data) {
    return this.instance.post(
      `/v1/ordem-servicos/${ordemServicoId}/ordem-servicos-itens`,
      data,
    );
  }

  updatePrestacaoServicoItens(ordemServicoId, id, data) {
    return this.instance.put(
      `/v1/ordem-servicos/${ordemServicoId}/ordem-servicos-itens/${id}`,
      data,
    );
  }

  finalizarPrestacaoServico(ordemServicoId, data) {
    return this.instance.put(
      `/v1/ordem-servicos/${ordemServicoId}/finalizar`,
      data,
    );
  }

  abrirPrestacaoServico(ordemServicoId) {
    return this.instance.patch(`/v1/ordem-servicos/${ordemServicoId}/abrir`);
  }

  removePrestacaoServicoItem(ordemServicoId, id) {
    return this.instance.delete(
      `/v1/ordem-servicos/${ordemServicoId}/ordem-servicos-itens/${id}`,
    );
  }
}

export default (...params) => new PrestacaoServicosFactory(...params);
